import React from "react";

const Spacer = () => <div className="h-3" />;

export default Spacer
